export default __webpack_public_path__ + "static/media/12_2_sub-detail.d84fdd01.png";